exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bi-filter-numeric-pane__instructions{font-size:12px}", ""]);

// exports
